module.exports = __webpack_public_path__ + "static/img/registration.5e3595f.png";